import React from "react";
import { Route, Redirect } from "react-router-dom";

/** is someone logged in? The pages read the user (its CDN folder) from localStorage as they first render */
export function isLoggedIn() {
  if (localStorage.getItem("user_id") === null) return false;
  try {
    return !!JSON.parse(localStorage.getItem("user"));
  } catch (e) {
    return false;
  }
}

/** the login page address that comes back to `location` once logged in */
export function loginUrl(location) {
  const here = location ? location.pathname + (location.search || "") : "/";
  return here === "/" || here.startsWith("/login") ? "/login" : "/login?next=" + encodeURIComponent(here);
}

/**
 * where to go after logging in: the page asked for (?next=), when it is a path of this app, else the library
 * @param search location.search of the login page
 */
export function nextAfterLogin(search) {
  const next = new URLSearchParams(search || "").get("next");
  return next && next.startsWith("/") && !next.startsWith("//") && !next.startsWith("/login") ? next : "/";
}

/**
 * A route for logged-in users only. Others are sent to the login page before the page renders, so pages can rely
 * on the user being in localStorage.
 */
export default function PrivateRoute({ component: Component, render, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => (isLoggedIn() ? (render ? render(props) : <Component {...props} />) : <Redirect to={loginUrl(props.location)} />)}
    />
  );
}
